import OneSignal from 'react-native-onesignal';
import Constants from "expo-constants";
OneSignal.setAppId(Constants?.manifest?.extra?.oneSignalAppId);

import { Provider } from 'react-redux';
import store from './store';

import * as Linking from 'expo-linking';
import 'react-native-gesture-handler';
import React, { useCallback, useMemo, useRef } from 'react';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View, TextInput, TouchableWithoutFeedback, TouchableOpacity as RNTouchableOpacity, Button, Platform, useWindowDimensions } from 'react-native';
if (Platform.OS === 'web') {
  global._frameTimestamp = null
}
import { Picker } from '@react-native-picker/picker';
import { NavigationContainer, StackActions } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { createDrawerNavigator, DrawerToggleButton } from '@react-navigation/drawer';
import {
  SafeAreaView,
  SafeAreaProvider,
  SafeAreaInsetsContext,
  useSafeAreaInsets,
  initialWindowMetrics,
} from 'react-native-safe-area-context';
import { useFonts } from 'expo-font';
import stylesheet from './Style'
import MyText from './MyText';
import MyTextInput from './MyTextInput';
import MyPicker from './MyPicker';
import Header from './Header';
import Footer from './Footer';
import Collapsible from 'react-native-collapsible';
import NewRequest from './NewRequest/NewRequest';
import Home from './Home';
import Dashboard from './Dashboard';
import PDF from './PDF';
import MyModal from './MyModal';
import MyRequests from './MyRequests';
import AppLoading from 'expo-app-loading';

// import * as SplashScreen from 'expo-splash-screen';
// SplashScreen.preventAutoHideAsync();

import AsyncStorage from '@react-native-async-storage/async-storage';
import * as SecureStore from 'expo-secure-store';
import 'react-native-get-random-values';
import { v4 as uuidv4 } from 'uuid';

import {
  BottomSheetModal,
  BottomSheetModalProvider,
  BottomSheetBackdrop
} from '@gorhom/bottom-sheet';

import axios from 'axios';
import { GestureHandlerRootView, TouchableOpacity } from 'react-native-gesture-handler';
import MyNotifications from './MyNotifications';
import CustomSidebarMenu from './CustomSidebarMenu';
import Login from './Login';
import Register from './Register';
import BottomSheetModalBackdrop from './BottomSheetModalBackdrop';
import CustomBottomSheetContent from './CustomBottomSheetContent';
import LandingPage from './LandingPage';
import ManageRequests from './VGroup/ManageRequests';
import ManageUsers from './VGroup/ManageUsers';
import Splash from './Splash';
import MyProfile from './MyProfile';
import SideMenu from './SideMenu';
import WebFooter from './WebFooter';

const Stack = createStackNavigator();
const Drawer = createDrawerNavigator();
const navigationRef = React.createRef();

const linking = {
  prefixes: ['http://localhost:19006', 'footprint://', 'https://footprint.mdataws.com'],
  config: {
    screens: {
      'Landing Page': '',
      'Landing Page': 'Home/:action?/:token?',
      'Register': 'Register',
      'My Requests': 'Requests/My',
      'New Request': 'Request/New',
      'Edit Request': 'Request/Edit/:id',
      'Request Info': 'Request/Info/:id',
      'Dashboard': 'Dashboard',
      'Documents': 'Documents',
      'My Notifications': 'Notifications',
      'Manage Requests': 'Requests/Manage',
      'Manage Users': 'Users/Manage',
      'User Info': 'User/:id',
      'My Profile': 'Profile',
      // 'Search': '?:id/Search',
      // 'Landing Page': '*',
    }
  },
};

OneSignal.addSubscriptionObserver(event => {
  console.log("OneSignal: subscription changed event:", event);
  console.log("OneSignal: subscription changed from userId:", event.from.userId);
  console.log("OneSignal: subscription changed to userId:", event.to.userId);
  console.log("OneSignal: subscription changed from pushToken:", event.from.pushToken);
  console.log("OneSignal: subscription changed to pushToken:", event.to.pushToken);
  console.log("OneSignal: subscription changed from isPushDisabled:", event.from.isPushDisabled);
  console.log("OneSignal: subscription changed to isPushDisabled:", event.to.isPushDisabled);
  console.log("OneSignal: subscription changed from isSubscribed:", event.from.isSubscribed);
  console.log("OneSignal: subscription changed to isSubscribed:", event.to.isSubscribed);

  if(event.to.userId){
    const saveDevice = async () => {
      let uuid = uuidv4();
      let fetchUUID = await AsyncStorage.getItem('uuid')
      if (fetchUUID) {
        uuid = fetchUUID
      }
      await AsyncStorage.setItem('uuid', uuid);

      let data = {
        uuid,
        onesignal_token: event.to.userId
      };

      axios.post('/api/saveDevice.php', data)
          .then((res) => {
            console.log(res);
          })
    }
    saveDevice().catch(console.error);
  }
});

RNTouchableOpacity.defaultProps = {
  ...TouchableOpacity.defaultProps,
  activeOpacity: 0.5,
  style: {
    outline: 0
  }
};
TouchableOpacity.defaultProps.activeOpacity = 0.5;
TouchableOpacity.defaultProps.style = {
  outline: 0
};

Text.defaultProps = {};
TextInput.defaultProps = {};
Text.defaultProps.allowFontScaling = false;
TextInput.defaultProps.allowFontScaling = false;

axios.defaults.baseURL = 'https://footprint.mdataws.com';
axios.defaults.withCredentials = true;

// To open native app if it exists. Otherwise this does nothing
// TODO fix navigation from deeplink
if(Platform.OS==='web')
  window.location.replace("gr.mdata.footprint://"+window.location.pathname);

export default function App() {
  const css = stylesheet();
  
  const [user, setUser] = React.useState(null);
  const [initial, setInitial] = React.useState('');
  const [splashFinished, setSplashFinished] = React.useState(false);

  const bottomSheetModalRef = useRef(null);
  const handlePresentModalPress = useCallback(() => {
    bottomSheetModalRef.current?.present();
  }, []);
  const handleSheetChanges = useCallback((index) => {
    console.log('handleSheetChanges', index);
  }, []);

  const navigationRef = React.useRef();

  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalHeader, setModalHeader] = React.useState('');
  const [modalBody, setModalBody] = React.useState('');
  const [modalCallback, setModalCallback] = React.useState(null);

  const [notificationsKey, setNotificationsKey] = React.useState(0);

  const [addedAxiosInterceptors, setAddedAxiosInterceptors] = React.useState(false);
  const [autoLogin, setAutoLogin] = React.useState(false);

  let [fontsLoaded] = useFonts({
    'Comfortaa-Light': require('./assets/fonts/Comfortaa-Light.ttf'),
    'Comfortaa-Regular': require('./assets/fonts/Comfortaa-Regular.ttf'),
    'Comfortaa-Medium': require('./assets/fonts/Comfortaa-Medium.ttf'),
    'Comfortaa-SemiBold': require('./assets/fonts/Comfortaa-SemiBold.ttf'),
    'Comfortaa-Bold': require('./assets/fonts/Comfortaa-Bold.ttf'),
    'futur': require('./assets/fonts/futur.otf'),
    'Futura Bold': require('./assets/fonts/futura-bold.otf'),
    'Futura Book': require('./assets/fonts/futura-book.otf'),
    'Futura Heavy': require('./assets/fonts/futura-heavy.otf'),
    'Futura Medium': require('./assets/fonts/futura-medium.otf'),
  });

  OneSignal.setNotificationWillShowInForegroundHandler(receivedEvent => {
    console.log(receivedEvent);
    setNotificationsKey(prev => prev+1);
  });

  OneSignal.setInAppMessageClickHandler(handler => {
    //clicked on inapp
    console.log('clicked inapp');
    // OneSignal.removeTriggerForKey('showPrompt');
  })

  OneSignal.setInAppMessageLifecycleHandler(event => {
    //received inapp, for some reason this is not called
    // OneSignal.removeTriggerForKey('showPrompt');
  })

  OneSignal.setNotificationOpenedHandler(openedEvent => {
    console.log("OneSignal: notification opened:", openedEvent);
    const { action, notification } = openedEvent;
    if(notification.additionalData?.id){
      setTimeout(async() => {
        if(notification.additionalData?.dbId){
          let notifications = JSON.parse(await AsyncStorage.getItem('notifications')??'{}');
          notifications[notification.additionalData.dbId] = true;
          await AsyncStorage.setItem('notifications', JSON.stringify(notifications)); 
        }
        setNotificationsKey(prev => prev+1);
        if (navigationRef.current?.isReady()) {
          navigationRef.current.push('Request Info', { id: notification.additionalData.id });
        }
      },100);
    }
  });

  const url = Linking.useURL();
  if (url) {
    const { hostname, path, queryParams } = Linking.parse(url);

    if(queryParams.id){
      setTimeout(() => {
        if (navigationRef.current?.isReady()) {
          navigationRef.current.push('Request Info', { id: queryParams.id });
        }
      },100);
    }
  }

  if(!addedAxiosInterceptors){
    axios.interceptors.response.use(
      (response) => {
        return response
      },
      async (error) => {
        console.log("Error: " + error);
        const originalRequest = error.config

        if (
          error.response.status === 401 &&
          (originalRequest.url === '/api/user/loginToken.php')
        ) {
          console.log("Invalid login credentials");
          setInitial('Landing Page');
          if (navigationRef.current?.isReady()) {
            navigationRef.current.push('Landing Page');
          }
          return Promise.reject(error)
        }
        if(error.response.status === 401 && originalRequest.url === '/api/user/login.php'){
          return Promise.reject(error)
        }
        if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          return axios
            .post('/api/user/loginToken.php', {
              token: await AsyncStorage.getItem('token'),
              uuid: await AsyncStorage.getItem('uuid')
            })
            .then(res => {
              if (res.status === 200) {
                console.log("Logged in");
                return axios(originalRequest)
              }
            })
        }
        return Promise.reject(error)
      }
    )
    setAddedAxiosInterceptors(true);
  }

  React.useEffect(() => {
    // to prompt in-app
    const prompt = async () => {
      const deviceState = await OneSignal.getDeviceState();
      console.log(deviceState);
      if(deviceState && !deviceState.hasNotificationPermission){
        console.log('show prompt');
        OneSignal.addTrigger('showPrompt', 'true');
        setTimeout(() => {
          OneSignal.removeTriggerForKey('showPrompt');
        },100);
      }
    }
    // declare the data fetching function
    const login = async () => {
      const token = await AsyncStorage.getItem('token')??'';
      const uuid = await AsyncStorage.getItem('uuid')??'';
      if(token && uuid){
        axios.post('/api/user/loginToken.php', {
          token,
          uuid
        }).then(async(res) => {
          setUser(res.data);
          if(!res.data.isVGroup){
            setInitial('My Requests');
          }
          else{
            setInitial('Manage Requests');
          }
          // if (navigationRef.current?.isReady()) {
          //   console.log("navigation ref ready");
          //   if(!res.data.isVGroup){
          //     navigationRef.current.reset({
          //       index: 0,
          //       routes: [{ name: 'My Requests' }],
          //     });  
          //   }
          //   else{
          //     navigationRef.current.reset({
          //       index: 0,
          //       routes: [{ name: 'Manage Requests' }],
          //     });  
          //   }
          //   // navigationRef.current.replace('My Requests');
          // }
        }).catch(() =>{

        }).finally(() => {
          setAutoLogin(true);
        })
      }
      else{
        setAutoLogin(true);
      }
    }
    const saveDevice = async () => {
      console.log("Save device");
      let uuid = uuidv4();
      let fetchUUID = await AsyncStorage.getItem('uuid')??'';
      if (fetchUUID) {
        uuid = fetchUUID
      }
      await AsyncStorage.setItem('uuid', uuid);

      let data = {
        uuid,
        onesignal_token: ''
      };

      axios.post('/api/saveDevice.php', data)
          .then((res) => {
            console.log(res);
          })
    }
    setTimeout(() => {
      prompt().catch(console.error);
    }, 5000)
    saveDevice().catch(console.error);
    login().catch(console.error);
    console.log('run once');
  }, [])

  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} pressBehavior='close' />,
    []
  );
  
  // return <>
  //   <MyText>
  //     {autoLogin?"Login":"Not login"}
  //   </MyText>
  //   <MyText>
  //     {canLoad?"Can load":"Can Not load"}
  //   </MyText>
  //   <MyText>
  //     {fontsLoaded?"Fonts loaded":"Fonts Not loaded"}
  //   </MyText>
  // </>
  const {height, width} = useWindowDimensions();

  const Content = (nav, child) => {
    return (
      <>
        <View style={{flexDirection: 'row', flex: 1}}>
          {
            width >= 992?
            <View style={{flexGrow: 0, flexShrink: 0, flexBasis: 230}}>
              <SideMenu user={user} setUser={setUser} navigation={nav.navigation} route={nav.route} />
            </View>
            :null
          }
          <View style={{flex: 1}}>
            {child}
          </View>
        </View>
        {
          Platform.OS!=='web'?
          <Footer user={user} navigation={nav.navigation} style={{flexGrow: 0, flexShrink: 0, flexBasis: 61}}/>
          :null
        }
      </>
    )
  }

  return (
    <>
      {
        (!autoLogin || !fontsLoaded || !splashFinished)?
        null:
        <GestureHandlerRootView style={{ flex: 1 }}>
          <Provider store={store}>
            <BottomSheetModalProvider>
              <NavigationContainer ref={navigationRef} linking={linking} fallback={<Text>Loading...</Text>}>
                <StatusBar style='light' />
                <BottomSheetModal
                  ref={bottomSheetModalRef}
                  index={1}
                  snapPoints={[250, user?.isVGroup?420:380]}
                  onChange={handleSheetChanges}
                  detached={false}
                  backdropComponent={renderBackdrop}
                >
                  <CustomBottomSheetContent user={user} setUser={setUser} navigation={navigationRef} bottomSheet={bottomSheetModalRef} />
                </BottomSheetModal>
                <View style={Platform.OS==='web'?{flex: 0, height: '100vh', minHeight: '100vh'}:{flex: 1}}>
                  <Stack.Navigator
                      // ref={navigationRef}
                      initialRouteName={initial}
                      screenOptions={{
                        // drawerPosition: 'left',
                        header: (props) => <Header {...props} user={user} bottomSheet={bottomSheetModalRef} style={{position: 'absolute', top: 0, right: 0, left: 0, flexGrow: 0, flexShrink: 0, flexBasis: 74}} key={notificationsKey}/>,
                        headerShown: true,
                        animationEnabled: Platform.OS==='ios',
                        gestureEnabled: Platform.OS==='ios'
                        // cardStyle: { flex: 1 }
                        // swipeEnabled: false,
                        // drawerActiveTintColor: '#461b6f',
                        // drawerLabelStyle: {fontFamily: 'Comfortaa-Regular', fontSize: 12},
                      }}
                      // drawerContent={(props) => <CustomSidebarMenu {...props} user={user} setUser={setUser} navigation={props.navigation} />}
                    >
                      {
                        !user?
                        <>
                          <Stack.Screen name="Landing Page" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => (
                              <>
                                <LandingPage navigation={props.navigation} autoLogin={autoLogin} setUser={setUser} isInfo={false} action={props?.route?.params?.action} token={props?.route?.params?.token} />
                              </>
                            )}
                          </Stack.Screen>
                          <Stack.Screen name="Register">
                            {props => (
                              <>
                                <Register navigation={props.navigation} isInfo={false} />
                              </>
                            )}
                          </Stack.Screen>
                        </>
                        :
                        <>
                          <Stack.Screen name="My Requests">
                            {props => Content(props, <MyRequests user={user} navigation={props.navigation} />)}
                          </Stack.Screen>
                          <Stack.Screen name="New Request">
                            {props => Content(props, <NewRequest user={user} navigation={props.navigation} isInfo={false} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Edit Request" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <NewRequest user={user} navigation={props.navigation} id={props.route.params.id} isInfo={false} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Request Info" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <NewRequest user={user} navigation={props.navigation} id={props.route.params.id} isInfo={true} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Dashboard">
                            {props => Content(props, <Dashboard user={user} navigation={props.navigation}/>)}
                          </Stack.Screen>
                          <Stack.Screen name="Documents">
                            {props => Content(props, <PDF/>)}
                          </Stack.Screen>
                          <Stack.Screen name="My Notifications">
                            {props => Content(props, <MyNotifications user={user} navigation={props.navigation} opened={() => setNotificationsKey(prev => prev+1)} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Manage Requests">
                            {props => Content(props, <ManageRequests user={user} navigation={props.navigation} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Manage Users">
                            {props => Content(props, <ManageUsers user={user} navigation={props.navigation} />)}
                          </Stack.Screen>
                          <Stack.Screen name="User Info" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <Register user={user} navigation={props.navigation} id={props.route.params.id} isInfo={true} />)}
                          </Stack.Screen>
                          <Stack.Screen name="My Profile" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <MyProfile user={user} setUser={setUser} navigation={props.navigation} />)}
                          </Stack.Screen>
                        </>
                      }
                  </Stack.Navigator>
                </View>
                {
                  Platform.OS==='web'?
                  <WebFooter/>
                  :null
                }
                <MyModal />
              </NavigationContainer>
            </BottomSheetModalProvider>
          </Provider>
        </GestureHandlerRootView>
        }
        <Splash done={(autoLogin && fontsLoaded && splashFinished)} finished={() => setSplashFinished(true)}/>
      </>
    );
}

const styles = StyleSheet.create({
  background: {
    flex: 1,
    backgroundColor: '#F6F4F9',
    padding: 20,
    overflow: 'scroll'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  bottomContainer: {
    flex: 1,
    padding: 24,
    justifyContent: 'center',
    backgroundColor: 'grey',
  },
  contentContainer: {
    flex: 1,
    // alignItems: 'center',
    paddingHorizontal: 30,
    paddingVertical: 10
  },
});
